import { render, staticRenderFns } from "./faqDetail.vue?vue&type=template&id=7c229f4e&scoped=true"
import script from "./faqDetail.vue?vue&type=script&lang=js"
export * from "./faqDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c229f4e",
  null
  
)

export default component.exports